export class AssetLibraryFakeDb {
  public static templates = [
    {name: 'template 1'},
    {name: 'template 2'},
    {name: 'template 3'},
    {name: 'template 4'},
    {name: 'template 5'}
  ];

  public static forms = [
    {name: 'Form 1'},
    {name: 'Form 2'},
    {name: 'Form 3'},
    {name: 'Form 4'},
    {name: 'Form 5'},
    {name: 'Form 6'},
    {name: 'Form 7'},
    {name: 'Form 8'},
    {name: 'Form 9'},
    {name: 'Form 10'},
    {name: 'Form 11'},
    {name: 'Form 12'},
    {name: 'Form 13'},
    {name: 'Form 14'},
    {name: 'Form 15'},
    {name: 'Form 16'},
    {name: 'Form 17'},
    {name: 'Form 18'}
  ]
}
